export default "__VITE_ASSET__OB5oVx1I__"